<template>
  <div id="values">
    <div class="mt-8 md:grid md:grid-cols-2">
      <SectionHeader icon="description" :title="__('Job Description')" />
    </div>

    <div class="relative mt-8 rounded-app bg-white p-8 shadow-md">
      <div>
        <VisualEditor
          v-model="data.job.description"
          :label="__('What the job involves')"
          :required="isJobTemplate ? false : true"
          :errors="errors.description"
        />

        <VisualEditor
          v-model="data.job.experience_needed"
          :label="__('Experience Needed')"
          class="mt-4"
          :errors="errors.experience_needed"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref } from 'vue';
  import {
    Button,
    Icon,
    FormMultiselect,
    SectionHeader,
    Textarea,
    VisualEditor
  } from '../../../../components/global';

  import { useForm } from '../../../../utils';
  import { useToast } from 'vue-toastification';
  import { __ } from '../../../../helpers';

  const props = defineProps({
    data: {
      type: Object,
      mandatory: true
    },
    errors: {
      type: Object,
      mandatory: true
    },
    isJobTemplate: {
      type: Boolean,
      default: false
    }
  });

  const toast = useToast();
</script>
